import { render, staticRenderFns } from "./nav-layout-home.vue?vue&type=template&id=27cc8eca&scoped=true"
import script from "./nav-layout-home.vue?vue&type=script&lang=js"
export * from "./nav-layout-home.vue?vue&type=script&lang=js"
import style0 from "./nav-layout-home.vue?vue&type=style&index=0&id=27cc8eca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cc8eca",
  null
  
)

export default component.exports